import * as Sentry from '@sentry/react';

import { env, isProd } from '@/config/env';

let initialized = false;

export function initSentry(): void {
  if (initialized) {
    return;
  }
  if (!env.VITE_SENTRY_DSN) {
    return;
  }
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_APP_ENV,
    tracesSampleRate: isProd ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
  });
  initialized = true;
}

export { Sentry };
